import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class ClientService {

  getClient(client_id) {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_BASE_URL + "/client/api/v1/client/" + client_id,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  listClients(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/client/api/v1/clients",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  setClient(data) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/client/api/v1/client",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        client: data
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  deleteClient(id) {
    return axios({
      method: 'delete',
      url: process.env.VUE_APP_BASE_URL + "/client/api/v1/client?id=" + id,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  deleteClients(ids) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/client/api/v1/delete_clients",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: {
        ids: ids
      }
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

}
